import { render, staticRenderFns } from "./share.vue?vue&type=template&id=deee8bdc&scoped=true&"
import script from "./share.vue?vue&type=script&lang=ts&"
export * from "./share.vue?vue&type=script&lang=ts&"
import style0 from "./share.vue?vue&type=style&index=0&id=deee8bdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee8bdc",
  null
  
)

export default component.exports